// extracted by mini-css-extract-plugin
export var amount = "styles-module--amount--d69d9";
export var button = "styles-module--button--22250";
export var container = "styles-module--container--e29c5";
export var content = "styles-module--content--a7285";
export var description = "styles-module--description--73134";
export var firstTitle = "styles-module--firstTitle--84f35";
export var freebet = "styles-module--freebet--a02ca";
export var image = "styles-module--image--6feb6";
export var imageMobile = "styles-module--imageMobile--8d007";
export var images = "styles-module--images--1ad56";
export var ru = "styles-module--ru--81b00";
export var rulesLink = "styles-module--rulesLink--be22d";
export var secondTitle = "styles-module--secondTitle--c0851";
export var text = "styles-module--text--ab2fb";
export var title = "styles-module--title--c935f";